// While the machine is busy or full (spec "Machine load"): a banner over the panes with the agent's words (what's
// wrong, what uses the most), "See what's running" and Hide, which hides it until it gets worse or comes back after
// clearing. Amber while busy, red while full; the same banner as the Mac's and the iPhone's.

import { IconCpu, IconDatabase, IconGauge, IconX } from '@tabler/icons-react';
import { showsLoad, store, useStore } from '../store';
import { Button, Ic, Tool } from './ds';
import { BannerSlot } from './BannerSlot';
import { useActions } from './Workspace';

const ICON = { memory: IconGauge, cpu: IconCpu, disk: IconDatabase } as const;

export function LoadBanner() {
  const a = useActions();
  const load = useStore((s) => s.machineLoad);
  const shown = useStore(showsLoad);
  return (
    <BannerSlot open={shown}>
    <div className="ws-banner" data-size="lg" data-tone={load.state === 'full' ? 'fault' : 'attn'} role="status" data-testid="load-banner">
      <span className="ws-banner-icon">
        <Ic icon={ICON[load.why ?? 'memory']} />
      </span>
      <span className="ws-notice-text">
        <span className="ws-notice-title" data-testid="load-title">
          {load.title}
        </span>
        {load.detail && <span className="ws-notice-body">{load.detail}</span>}
      </span>
      <span className="ws-banner-actions">
        <Button size="sm" onClick={a.openMachine} data-testid="load-activity">
          See what’s running
        </Button>
        <Tool
          icon={IconX}
          label="Hide"
          sub="until it gets worse"
          align="end"
          data-testid="load-hide"
          onClick={() => store.set({ loadHiddenAt: store.get().machineLoad.state })}
        />
      </span>
    </div>
    </BannerSlot>
  );
}
